import { isGoGameEnv } from 'App/constants';

import { useLoadFavorites, useSaveFavorites } from './data';

export const FavoritePages = ({ children }) => {
  const { data: favorites } = useLoadFavorites({
    enabled: isGoGameEnv,
  });

  const [saveFavorites] = useSaveFavorites();

  const handleChange = (ids) => saveFavorites({ ids });

  return children({
    favorites,
    onChange: handleChange,
  });
};
